/**
 * StatusBadge Component
 *
 * Displays status with color-coded badges for result statuses.
 * Supports 4 variants: none, error, empty, complete
 */

import React from 'react';
import { ResultStatus } from '../../types/result';

interface StatusBadgeProps {
  status: ResultStatus;
  className?: string;
}

const STATUS_STYLES: Record<ResultStatus, string> = {
  none: 'bg-gray-100 text-gray-800',
  error: 'bg-red-100 text-red-800',
  empty: 'bg-yellow-100 text-yellow-800',
  complete: 'bg-green-100 text-green-800',
};

const STATUS_LABELS: Record<ResultStatus, string> = {
  none: 'Not Executed',
  error: 'Error',
  empty: 'Incomplete',
  complete: 'Complete',
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  const baseClasses = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';
  const statusClasses = STATUS_STYLES[status];
  const label = STATUS_LABELS[status];

  return (
    <span className={`${baseClasses} ${statusClasses} ${className}`} aria-label={`Status: ${label}`}>
      {label}
    </span>
  );
};
